import React, { Component } from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import { Link } from "react-router-dom"

import Lazyload from "react-lazyload-fadein"
import { ClipLoader } from "react-spinners"

import Sidebar from "../components/Sidebar.js"
import { getStories, getStoriesCount, getStoriesLasts } from "../helpers/api.js"
import { chunk } from "../helpers/utils.js"
import { categories } from "../helpers/const.js"
import { cdnUrl } from "../config.prod"
import { Seo } from "../components/Seo.js"

class Stories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      categories,
      stories: null,
      selectedCategory: "featured",
      selectedStory: "",
      loading: true,
      storiesCounter: null,
      lastEvaluatedKeys: [
        {}
      ]
    }

    this.onChangePage = this.onChangePage.bind(this)
  }

  getStoryByCategory(category = "featured") {
    getStories(category, 12, {})
      .then(data => {
        this.setState(({ lastEvaluatedKeys }) => {
          return ({
            stories: chunk(data.items.map(({ PK, cover }) => ({
              alias: PK,
              cover: cover.includes("d1gi8uwv7isx4g.cloudfront.net") ? cover.replace("thumbs", "medium") : cover.substring(0, 5) === "https" ? cover : `${cdnUrl}/medium/${cover}.jpg`
            })), 4),
            lastEvaluatedKeys,
            loading: false
          })
        })
      })
  }

  onChangePage(newPage) {
    this.setState({
      loading: true
    })
    getStories(null, 12, this.state.lastEvaluatedKeys[newPage - 1])
      .then(data => {
        if (data) {
          this.setState(prevState => {
            const lastEvaluatedKeys = prevState.lastEvaluatedKeys
            lastEvaluatedKeys[newPage] = {
              last: data.LastEvaluatedKey,
              lastTimestamp: data.lastTimestamp
            }
            return ({
              stories: chunk(data.items.map(({ PK, cover }) => ({ alias: PK, cover })), 4),
              lastEvaluatedKeys,
              activePage: newPage,
              loading: false
            })
          })
        }
      })
      .catch(console.error)
  }

  componentDidMount() {
    this.getStoryByCategory()

    getStoriesLasts(this.state.selectedCategory, 12)
      .then(lasts => {
        this.setState({
          lastEvaluatedKeys: lasts
        })
      })
      .catch(console.error)

    getStoriesCount()
      .then(({ Count }) => this.setState({ storiesCounter: Count }))

  }

  render() {
    return(
      <Grid fluid>
        <Seo title="Stories"></Seo>
        <Row>
          <Col md = { 1 }>
            <Sidebar />
          </Col>
          <Col md = { 11 }>
            <div className = { "category-filters" }>
              {
                this.state.categories.map(row => (
                  <Row>
                    {
                      row.map(category => (
                        <Col xs = { 6 } md = { 3 } >
                          <div
                            className = { "category" }
                            style = {{
                              backgroundColor: this.state.selectedCategory === category.id ? "#F0EFEF" : "white"
                            }}
                            onClick = {
                              () => this.setState({
                                selectedCategory: category.id,
                                loading: true
                              }, () => this.getStoryByCategory(category.id))
                            }
                          >
                            { category.value }
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                ))
              }
            </div>
            <div className = { "stories" }>
              {
                (this.state.loading &&
                  <ClipLoader
                    css = {{ marginLeft: "46%" }}
                    sizeUnit = { "px" }
                    size = { 50 }
                    color = { "#000" }
                  />
                ) ||
                <div>
                  {
                    this.state.stories &&
                      this.state.stories.map(row => (
                        <Row className={"story-grid center-vertically-sm"}>
                          {
                            row.map(({ alias, cover }) => (
                              <Col sm = { 6 } md = { 3 } className={"story-column"}>
                                <div className={"img-wrapper"}>
                                  <Link to={`/stories/${alias}`}>
                                    <Lazyload height={300}>
                                      {
                                        onLoad => (
                                          <Image
                                            src={cover}
                                            onLoad={onLoad}
                                          />
                                        )
                                      }
                                    </Lazyload>
                                  </Link>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>
                      ))
                  }
                </div>
              }
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default Stories



// WEBPACK FOOTER //
// ./src/containers/Stories.js